<template>
  <div class="dashboard-pages">
    <v-card>
      <v-card-text>
        <h3 class="pb-2 grey--text">{{ $t('Staff Sections') }}</h3>
        <ul class="sub-sections-list">
          <li v-for="(link, index) in filterSubMenu(sidebarSubLinks['staff'])" :key="index">
            <span class="px-2">{{ $vuetify.rtl ? '&larr;' : '&rarr;' }}</span>
            <v-tooltip :right="!$vuetify.rtl" :left="$vuetify.rtl">
              <router-link slot="activator" class="text-capitalize" :to="link.to">{{ $t(link.title) }}</router-link>
              <span>{{ $t('Manage') }} {{ $t(link.title) }}</span>
            </v-tooltip>
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'Staff',

  computed: {
    ...mapGetters({
      sidebarSubLinks: 'dashboard/sidebarSubLinks'
    })
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Staff Sections'),
      icon: 'fa-id-card-alt'
    })
  },

  methods: {
    filterSubMenu(menu) {
      return menu.filter(item => helpers.userHasSidebarPermissions(item.id))
    }
  }
}
</script>

<style scoped>
.sub-sections-list {
  list-style-type: none;
  padding: 0;
}
.sub-sections-list li {
  list-style-type: none;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
